import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

const DraggableNewScopeRow = ({ id, children, data }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging,
    transform,
    transition,
  } = useDraggable({
    id: id,
    data: {
      row: "new_scope",
      type: "row", // Specify the type of draggable item
      values: {
        ...data,
        is_new_scope: true,
      },
    },
  });

  return (
    <tr
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={`text-truncate ${isDragging ? "dragging" : ""}`}
      style={{
        cursor: "grab",
        opacity: isDragging ? 0.7 : 1,
        transform: CSS.Transform.toString(transform),
        transition,
        backgroundColor: isDragging ? "#f8f9fa" : "transparent",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </tr>
  );
};

export default DraggableNewScopeRow;
